import React from 'react';
import "./DetailsContent.css";


const DetailsContent = ({ cardDetails, abilities, onClose }) => {
    return (
        <div className="details-content-component">
            <div className="card details-content align-items-center">
                {/* Skills */}
                {cardDetails.summonerSkills && cardDetails.summonerSkills.length > 0 && (
                    <div className="detailled_skill">
                        <div className="skills">
                            <h3 className="text-center mb-4 mt-2">SKILL</h3>
                            {cardDetails.summonerSkills.map((skill, index) => (
                                <p key={index}>
                                    {index + 1} ~ {skill.skill}
                                    <br/>
                                    {skill.skillDetail}
                                </p>
                            ))}
                        </div>
                    </div>
                )}

                {/* Base Effects */}
                {cardDetails.baseEffects && cardDetails.baseEffects.length > 0 && (
                    <div className="base_effect">
                        <h3 className="text-center">BASE EFFECT :</h3>
                        <br/>
                        {cardDetails.baseEffects.map((effect, index) => (
                            <div key={index} className="effect">
                                <span className="effect-title">
                                    {effect.effect && effect.effect.length > 0 ? (
                                        <span dangerouslySetInnerHTML={{__html: `~ ${effect.effect}`}}/>
                                    ) : (
                                        ''
                                    )}
                                </span>
                                <span className="effect-detail"> {effect.effectDetail}</span>
                            </div>
                        ))}
                    </div>
                )}

                {/* Actions */}
                {cardDetails.actions && cardDetails.actions.length > 0 && (
                    <div className="action">
                        {cardDetails.actions.map((action, index) => (
                            <div key={index} className="action">
                                <h3 className="text-center">ACTION :</h3>
                                <br/>
                                {action.tossOfCoin && action.tossOfCoin.length > 0 && (
                                    <div className="toss-coin-action d-flex align-items-center justify-content-center">
                                        <img className="toss_coin mx-2" src="assets/icons/coins/coin_flip.png" alt="" width="30px"/>
                                        <h3 className="text-center">Toss of Coin </h3>
                                        <img className="toss_coin mx-2" src="assets/icons/coins/coin_flip.png" alt="" width="30px"/>
                                    </div>
                                )}
                                {action.tossOfCoin && action.tossOfCoin.map((coin, idx) => (
                                    <div key={idx} className="coin-action">
                                        <div className="toss-action">
                                            {coin.success && coin.success.description && (
                                                <p>
                                                    ~ {coin.cost > 0 && (coin.cost)}
                                                    <img className="toss_coin" src="assets/icons/coins/coin_flip.png" alt="" width="30px"/>
                                                    : Success: {coin.success.description} {coin.success.detail}
                                                </p>
                                            )}
                                            {coin.fail && coin.fail.description && (
                                                <p>
                                                    - Fail: {coin.fail.description} {coin.fail.detail}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                ))}

                                {action.directPurchase && action.directPurchase.length > 0 && (
                                    <div className="direct-purchase-action d-flex align-items-center justify-content-center">
                                        <img className="direct-purchase mx-2" src="assets/icons/coins/pay_coin.png" alt="" width="30px"/>
                                        <h2 className="text-center">Direct purchase :</h2>
                                        <img className="direct-purchase mx-2" src="assets/icons/coins/pay_coin.png" alt="" width="30px"/>
                                    </div>
                                )}
                                <br/>
                                {action.directPurchase && action.directPurchase.map((purchase, idx) => (
                                    <div key={idx} className="direct-purchase-action">
                                        {purchase.cost > 100 ? (
                                            <p>
                                                ~ {(purchase.cost > 0 && (Math.floor(purchase.cost / 100) % 10))}
                                                <img className="ether-cost" src="assets/icons/ether.png" alt="" width="30px"/>: {purchase.action}
                                                <br/>
                                                {purchase.actionDetail}
                                            </p>
                                        ) : (
                                            <p>
                                                ~ {(purchase.cost > 0 && (purchase.cost))} <img className="coin-icon" src="assets/icons/coins/pay_coin.png" alt="" width="30px"/>: {purchase.action}
                                                <br/>
                                                {purchase.actionDetail}
                                            </p>
                                        )}
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                )}

                                                                {/* Affichage des HP si healingPoints existe et est non null/non vide */}
                                                                {(cardDetails.healingPoints !== undefined && cardDetails.healingPoints !== null && cardDetails.healingPoints !== '') && (
                                                                    <div className="stats d-flex justify-content-center mt-4">
                                                                        <span>{cardDetails.healingPoints} HP</span>
                                                                    </div>
                                                                )}

                                                                {/* Affichage du conteneur stats uniquement si au moins une valeur (attack/defence) est définie */}
                                                                {((cardDetails.attack !== undefined && cardDetails.attack !== null && cardDetails.attack !== '') ||
                                                                  (cardDetails.defence !== undefined && cardDetails.defence !== null && cardDetails.defence !== '')) && (
                                                                    <div className="stats d-flex justify-content-center mt-4">
                                                                        {cardDetails.attack !== undefined && cardDetails.attack !== null && cardDetails.attack !== '' && (
                                                                            <>
                                                                                <img className="sword" src="assets/icons/sword.png" alt="Sword Icon" width="14.8px" height="34px"/>
                                                                                <h3 style={{marginRight: '15px'}}>{cardDetails.attack === -1 ? '*' : cardDetails.attack}</h3>
                                                                            </>
                                                                        )}
                                                                        {cardDetails.defence !== undefined && cardDetails.defence !== null && cardDetails.defence !== '' && (
                                                                            <>
                                                                                <img className="shield" src="assets/icons/shield.png" alt="Shield Icon" width="20px" height="34px"/>
                                                                                <h3 style={{marginRight: '15px'}}>{cardDetails.defence === -1 ? '*' : cardDetails.defence}</h3>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                )}
                <br/>
                <div className="flavorText d-flex justify-content-center">
                    {cardDetails.flavorText && (
                        <>
                            ~ {cardDetails.flavorText} ~
                        </>
                    )}
                </div>
                <br/>
                <div className="d-flex justify-content-center">
                    <p className="text-center">
                        {cardDetails.cardNumber} {cardDetails.edition}
                        <br/>
                        Illus. {cardDetails.illustrator.join(', ')}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default DetailsContent;
